/* eslint-disable import/prefer-default-export */

export const ADD_TEAM_MEMBER_CLICKED = 'ADD_TEAM_MEMBER_CLICKED';
export const CANCEL_NEW_INVITATION = 'CANCEL_NEW_INVITATION';

export const NEW_INVITATION_FIRST_NAME_CHANGED = 'NEW_INVITATION_FIRST_NAME_CHANGED';
export const NEW_INVITATION_LAST_NAME_CHANGED = 'NEW_INVITATION_LAST_NAME_CHANGED';
export const NEW_INVITATION_EMAIL_CHANGED = 'NEW_INVITATION_EMAIL_CHANGED';
export const NEW_INVITATION_ROLE_ID_CHANGED = 'NEW_INVITATION_ROLE_ID_CHANGED';
export const NEW_INVITATION_COMPANY_CHANGED = 'NEW_INVITATION_COMPANY_CHANGED';
export const NEW_INVITATION_VENUE_OWNERSHIP_CLICKED = 'NEW_INVITATION_VENUE_OWNERSHIP_CLICKED';
export const NEW_INVITATION_CREATION_SUCCESS = 'NEW_INVITATION_CREATION_SUCCESS';
export const NEW_INVITATION_ERRORS_CHANGED = 'NEW_INVITATION_ERRORS_CHANGED';
export const NEW_INVITATION_SUBMITTING = 'NEW_INVITATION_SUBMITTING';
export const NEW_INVITATION_ENABLE_ALL_VENUES_CLICK = 'NEW_INVITATION_ENABLE_ALL_VENUES_CLICK';
export const NEW_INVITATION_DISABLE_ALL_VENUES_CLICK = 'NEW_INVITATION_DISABLE_ALL_VENUES_CLICK';

export const EDIT_TEAM_MANAGEABLE_CLICKED = 'EDIT_TEAM_MANAGEABLE_CLICKED';
export const EDIT_TEAM_MANAGEABLE_CANCELED = 'EDIT_TEAM_MANAGEABLE_CANCELED';
export const TEAM_MANAGEABLE_DELETED = 'TEAM_MANAGEABLE_DELETED';

export const TEAM_MANAGEABLE_TO_EDIT_FIRST_NAME_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_FIRST_NAME_CHANGED';
export const TEAM_MANAGEABLE_TO_EDIT_LAST_NAME_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_LAST_NAME_CHANGED';
export const TEAM_MANAGEABLE_TO_EDIT_EMAIL_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_EMAIL_CHANGED';
export const TEAM_MANAGEABLE_TO_EDIT_ROLE_ID_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_ROLE_ID_CHANGED';
export const TEAM_MANAGEABLE_TO_EDIT_COMPANY_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_COMPANY_CHANGED';
export const TEAM_MANAGEABLE_TO_EDIT_VENUE_OWNERSHIP_CLICKED = 'TEAM_MANAGEABLE_TO_EDIT_VENUE_OWNERSHIP_CLICKED';
export const TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK = 'TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK';
export const TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK = 'TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK';
export const TEAM_MANAGEABLE_TO_EDIT_UPDATED = 'TEAM_MANAGEABLE_TO_EDIT_UPDATED';
export const TEAM_MANAGEABLE_TO_EDIT_ERRORS_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_ERRORS_CHANGED';

// Search, Filter, Pagination
export const SEARCH_TERM_CHANGED = 'SEARCH_TERM_CHANGED';
export const ROLE_FILTER_CHANGED = 'ROLE_FILTER_CHANGED';
export const VENUE_FILTER_CHANGED = 'VENUE_FILTER_CHANGED';
export const CURRENT_PAGE_CHANGED = 'CURRENT_PAGE_CHANGED';
export const PAGE_SIZE_CHANGED = 'PAGE_SIZE_CHANGED';
export const SELECTED_MEMBER_IDS_CHANGED = 'SELECTED_MEMBER_IDS_CHANGED';
export const TOGGLE_MEMBER_SELECTION = 'TOGGLE_MEMBER_SELECTION';
export const SELECT_ALL_MEMBERS = 'SELECT_ALL_MEMBERS';
export const DESELECT_ALL_MEMBERS = 'DESELECT_ALL_MEMBERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SORT_CHANGED = 'SORT_CHANGED';

// Modal
export const OPEN_MEMBER_MODAL = 'OPEN_MEMBER_MODAL';
export const CLOSE_MEMBER_MODAL = 'CLOSE_MEMBER_MODAL';

// Team Functions
export const TEAM_FUNCTION_CREATED = 'TEAM_FUNCTION_CREATED';
export const TEAM_FUNCTION_UPDATED = 'TEAM_FUNCTION_UPDATED';
export const TEAM_FUNCTION_DELETED = 'TEAM_FUNCTION_DELETED';
export const TEAM_FUNCTION_FILTER_CHANGED = 'TEAM_FUNCTION_FILTER_CHANGED';

// Form-state changes for team_function_ids
export const NEW_INVITATION_TEAM_FUNCTION_IDS_CHANGED = 'NEW_INVITATION_TEAM_FUNCTION_IDS_CHANGED';
export const TEAM_MANAGEABLE_TO_EDIT_TEAM_FUNCTION_IDS_CHANGED = 'TEAM_MANAGEABLE_TO_EDIT_TEAM_FUNCTION_IDS_CHANGED';
